import { DecimalPipe } from '@angular/common'
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { authInterceptor } from '@core/interceptors/auth.interceptor'
import { traceHeaderInterceptor } from '@core/interceptors/trace-header.interceptor'
import { UserInfoState } from '@core/store/user/user.state'
import { AuthService, UserService } from '@core/services/api'
import { SocketService } from '@core/services/common/socket.service'
import { provideStore } from '@ngxs/store'
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core'
import { provideAnimations } from '@angular/platform-browser/animations'
import { provideRouter } from '@angular/router'
import { provideDaterangepickerLocale } from 'ngx-daterangepicker-bootstrap'
import { catchError, firstValueFrom, of } from 'rxjs'
import { routes } from './app.routes'
import { onboardingStep } from './utils/onboarding'

export const appConfig: ApplicationConfig = {
  providers: [
    DecimalPipe,
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([traceHeaderInterceptor, authInterceptor])),
    provideStore([UserInfoState], { compatibility: { strictContentSecurityPolicy: true } }),
    provideAppInitializer(() => {
      const userService = inject(UserService)
      const socketService = inject(SocketService)
      const authService = inject(AuthService)

      return firstValueFrom(
        userService.loadCurrentUser().pipe(catchError(() => of(null)))
      ).then((user) => {
        if (user && !onboardingStep(user)) {
          void socketService.connect()
          authService.startKeepalive()
        }
      })
    }),
    provideAnimations(),
    provideDaterangepickerLocale({
      separator: ' - ',
      cancelLabel: 'Cancel',
    }),
  ],
}
